import React, { Component } from 'react';
import { Space, Row, Col, Typography, message, Table } from 'antd';
import { AppstoreOutlined, SearchOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  ModalItem,
  InputItem,
  ButtonItem,
  dineroDisabledMask,
} from '../../../Components/Items';
import debounce from "lodash.debounce";
import IconCurrencyDollar from '../../../Icons/IconCurrencyDollar';
import moment from 'moment';

const { Text } = Typography;

class CobrarVenta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      ventas: [],
      totalVentas: 0,
      loading: false,
      currentPage: 1,
      pageSize: 10
    };

    // Aquí defines la función debounced
    this.debouncedConsultar = debounce(() => {
      this.consultarVentas();
    }, 500); // Puedes ajustar el delay en ms (ej. 500)
  }

  // Consultar ventas cuando se abre el modal
  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.consultarVentas();
    }
    if (this.props.recargarVentas !== prevProps.recargarVentas && this.props.recargarVentas && this.props.visible) {
      this.consultarVentas();
    }
  }

  // Función para obtener el precio correcto basado en precioId
  obtenerPrecioPorId = (insumo) => {
    // Si no hay precioId en props, usar el primer precio o el costo
    if (!this.props.precioId) {
      return insumo.precios && insumo.precios.length > 0
        ? insumo.precios[0].precio
        : insumo.costo;
    }

    // Buscar el precio que coincida con el precioId
    const precioEncontrado = insumo.precios && insumo.precios.find(
      precio => precio.precioId === this.props.precioId
    );

    // Si encuentra el precio, devolverlo; si no, usar el costo como fallback
    return precioEncontrado ? precioEncontrado.precio : insumo.costo;
  };

  // Consultar insumos desde la API
  consultarVentas = () => {
    this.setState({ loading: true });

    const { searchTerm, currentPage, pageSize } = this.state;

    axios
      .post(
        "puntoVenta/selectVentasCobrarPaginado",
        {
          empresaId: this.props.empresaId,
          sesionId: this.props.sesionId,
          proyectoId: this.props.proyectoId,
          query: searchTerm,
          skip: (currentPage - 1) * pageSize,
          limit: pageSize
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            ventas: res.data.items.map((value) => {
              let numero = ''
              if (value.factura) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaSerie ? value.facturaSerie : 'F') + ' ' + value.facturaNumero
              }
              if (value.facturaGlobal) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaGlobalSerie ? value.facturaGlobalSerie : 'FG') + ' ' + (value.facturaGlobalNumero ? value.facturaGlobalNumero : '')
              }
              if (value.remision) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.remisionSerie ? value.remisionSerie : 'R') + ' ' + value.remisionNumero
              }
              return {
                ...value,
                fechaVenta: value.fechaFactura ? value.fechaFactura : value.fechaRemision,
                numero: numero,
                cliente: (value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)) + " - " + value.cliente.rfc,
                vendedor: value.vendedor ? (value.vendedor.nombre + " " + (value.vendedor.apellidoPaterno || "") + ' ' + (value.vendedor.apellidoMaterno || "")) : '',
                totalCobrar: value.totalPagar - (value.totalPagado || 0),
                accion: {
                  _id: value._id,
                  cancelacion: value.cancelacion,
                  dataFactura: !!value.dataFactura,
                  estado: value.estado,
                  estadoCosteo: value.estadoCosteo,
                  servicios: value.servicios,
                  estadoPago: value.estadoPago,
                  facturaGlobal: value.facturaGlobal,
                  sesionId: value.sesionId,
                  cajaId: value.cajaId,
                  factura: value.factura,
                  contado: value.contado,
                  remision: value.remision,
                  cuentasXC: value.cuentasXC,
                  envios: value.envios,
                  flete: value.flete,
                  ventaProgramada: value.ventaProgramada,
                },
              };
            }),
            totalVentas: res.data.total,
            loading: false
          });
        } else {
          message.error("No se encontraron ventas");
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.error("Error al consultar ventas:", error);
        message.error("Error al consultar ventas");
        this.setState({ loading: false });
      });

  };

  onSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value, currentPage: 1 }, () => {
      this.debouncedConsultar();
    });
  };

  onTableChange = (pagination) => {
    this.setState(
      {
        currentPage: pagination.current,
        pageSize: pagination.pageSize
      },
      () => {
        this.consultarVentas();
      }
    );
  };

  // Limpiar filtros al cerrar el modal
  handleCancel = () => {
    this.setState({
      searchTerm: '',
      ventas: [],
      currentPage: 1
    });
    this.props.onCancel();
  };

  // Agregar producto al carrito
  handleAddToCart = (product) => {
    this.props.onAddToCart(product);
  };

  handleCobrarVenta = (venta) => {
    this.props.handleCobrarVenta(venta);
  }

  // Columnas de la tabla de productos
  getProductColumns = () => [
    {
      title: 'Venta',
      dataIndex: 'numero',
      key: 'numero',
      width: "15%",
    },
    {
      title: 'Cliente',
      dataIndex: 'cliente',
      key: 'cliente',
      width: "30%",
    },
    {
      title: 'Fecha',
      dataIndex: 'fechaVenta',
      key: 'fechaVenta',
      render: (value) => moment(value).locale("es").format("L"),
      width: "15%",
    },
    {
      title: 'Total',
      dataIndex: 'totalCobrar',
      key: 'totalCobrar',
      render: (totalCobrar) => (
        <Text strong style={{ color: '#52c41a' }}>
          {dineroDisabledMask(totalCobrar)}
        </Text>
      ),
      width: "20%",
    },
    {
      title: 'Acción',
      key: 'action',
      render: (_, record) => (
        <ButtonItem
          type="primary"
          icon={<IconCurrencyDollar />}
          onClick={() => this.handleCobrarVenta(record)}
          verde
          lessTime
        >
          Cobrar
        </ButtonItem>
      ),
      width: "20%",
    }
  ];

  render() {
    const { visible } = this.props;
    const { loading, ventas, currentPage, pageSize, totalVentas } = this.state;

    return (
      <ModalItem
        title={
          <Space>
            <AppstoreOutlined style={{ color: '#00b5e2' }} />
            <span>Ventas por Cobrar</span>
          </Space>
        }
        visible={visible}
        onCancel={this.handleCancel}
        footer={null}
        width={1200}
        style={{ top: 20 }}
        destroyOnClose={true}
        spinning={loading}
        zIndex={1000}
      >
        {/* Filtros */}
        <Row gutter={16} style={{ marginBottom: '16px' }}>
          <Col span={24}>
            <InputItem
              prefix={<SearchOutlined />}
              placeholder="Buscar venta..."
              value={this.state.searchTerm}
              onChange={this.onSearchChange}
              size="large"
              allowClear
              autoFocus
            />
          </Col>
        </Row>

        {/* Información de resultados */}
        <div style={{ marginBottom: '16px' }}>
          <Text style={{ fontSize: '14px', color: '#666' }}>
            Mostrando {ventas.length} de {totalVentas} ventas
          </Text>
        </div>

        {/* Tabla de ventas */}
        <Table
          dataSource={ventas}
          columns={this.getProductColumns()}
          spinning={loading}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalVentas,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} de ${total} ventas`,
            pageSizeOptions: ['10', '20', '50'],
            showLessItems: true,
            hideOnSinglePage: false,
            simple: false
          }}
          onChange={this.onTableChange}
          scroll={{ y: 400 }}
          locale={{
            emptyText: loading ? 'Cargando ventas...' : 'No se encontraron ventas'
          }}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
  };
};

export default connect(mapStateToProps)(CobrarVenta);